import * as React from 'react';
import { actions, Errors, LocalForm } from 'react-redux-form';

import { AccountViewModel } from '@models/Account';
import { CreditCardPaymentViewModel } from '@models/Payment';

// import { PaymentCreditCard } from 'src/payment/_components/payment-credit-card.component';

export interface CreditCardComponentProperties {
  readonly creditCard?: AccountViewModel;
  readonly isCreditCardInvalid?: boolean;
  readonly isError?: boolean;
  readonly buttonRef?: (button: HTMLButtonElement) => void;
  readonly saveCallback?: (creditCard: CreditCardPaymentViewModel) => void;
}

interface CreditCardComponentState {
  formDispatcher?: Function;
}

export class CreditCardComponent extends React.Component<CreditCardComponentProperties, CreditCardComponentState> {
  constructor(props: CreditCardComponentProperties) {
    super(props);
    this.state = {
      formDispatcher: undefined
    };
  }

  public componentDidUpdate(
    prevProps: Readonly<CreditCardComponentProperties>,
    prevState: Readonly<CreditCardComponentState>
  ): void {
    if (this.state.formDispatcher) {
      if (this.props.isError === true) {
        this.state.formDispatcher(actions.setErrors('local', 'Unable to process your request, please try again.'));
      } else if (this.props.isCreditCardInvalid === true) {
        this.state.formDispatcher(actions.setErrors('local', 'Please check credit card information and try again.'));
      }
    }
  }
  render() {
    return (
      <LocalForm
        getDispatch={d => this.setState({ formDispatcher: d })}
        hideNativeErrors={false}
        model="local"
        onSubmit={this.props.saveCallback}
      >
        <Errors className="error" model="local" />
        {/*this.state.formDispatcher && (
          <PaymentCreditCard
            defaultSavedCreditCard={
              this.props.creditCard ? { account: this.props.creditCard, name: 'some dumb name' } : undefined
            }
            formDispatcher={this.state.formDispatcher!}
          />
          )*/}
        <div className="row end-xs mt-10 mb-10">
          <button className="btn btn-primary" hidden={true} type="submit" ref={this.props.buttonRef}>
            Save
          </button>
        </div>
      </LocalForm>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/credit-cards/_components/credit-card.component.tsx